import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './central-heating.reducer';

export const CentralHeatingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const centralHeatingEntity = useAppSelector(state => state.centralHeating.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="centralHeatingDetailsHeading">
          <Translate contentKey="apiLocationApp.centralHeating.detail.title">CentralHeating</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.centralHeating.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.centralHeating.date">Date</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.centralHeating.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.centralHeating.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllHouseholds">
              <Translate contentKey="apiLocationApp.centralHeating.totalAllHouseholds">Total All Households</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.totalAllHouseholds}</dd>
          <dt>
            <span id="gasCentralHeating">
              <Translate contentKey="apiLocationApp.centralHeating.gasCentralHeating">Gas Central Heating</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.gasCentralHeating}</dd>
          <dt>
            <span id="electricCentralHeating">
              <Translate contentKey="apiLocationApp.centralHeating.electricCentralHeating">Electric Central Heating</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.electricCentralHeating}</dd>
          <dt>
            <span id="oilCentralHeating">
              <Translate contentKey="apiLocationApp.centralHeating.oilCentralHeating">Oil Central Heating</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.oilCentralHeating}</dd>
          <dt>
            <span id="solidFuelCentralHeating">
              <Translate contentKey="apiLocationApp.centralHeating.solidFuelCentralHeating">Solid Fuel Central Heating</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.solidFuelCentralHeating}</dd>
          <dt>
            <span id="otherCentralHeating">
              <Translate contentKey="apiLocationApp.centralHeating.otherCentralHeating">Other Central Heating</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.otherCentralHeating}</dd>
          <dt>
            <span id="noCentralHeating">
              <Translate contentKey="apiLocationApp.centralHeating.noCentralHeating">No Central Heating</Translate>
            </span>
          </dt>
          <dd>{centralHeatingEntity.noCentralHeating}</dd>
        </dl>
        <Button tag={Link} to="/central-heating" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/central-heating/${centralHeatingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CentralHeatingDetail;
